// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .device-container{
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        background-color: white;
        position: absolute;
        top: 2vh;
        right: 0px;
        height: 95%;
        width: 70%;
        box-sizing: border-box;
        border-radius: 10px 0px 0px 10px;
    }
    .device-container-header{
        color: white;
        background-color: rgba(155, 30, 30, 0.952);
        padding: 15px;
        border-radius: 10px 0px 0px 0px;
        display: flex;
        justify-content: space-between;
    }
    .device-container-header h3{
        margin: 0px;
        font-weight: lighter;
    }
    .device-container-header p{
        margin: 0px;
        margin-right: 20px;
        font-weight: lighter;
        font-size: 30px;
        cursor: pointer;
    }
    .device-container-header h4{
        margin: 0px;
        font-weight: lighter;
        font-size: 14px;
    }
    .device-container-navigation-bar{
        padding: 10px 0px;
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
    }
    .device-container-navigation-bar button{
        border: none;
        outline: none;
        margin: 0px 10px;
        border-radius: 80px;
        padding: 8px 15px;
        cursor: pointer;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
        background-color: transparent;
        text-wrap: nowrap;
    }
    .device-container-navigation-bar button:hover{
        background-color: lightgray;
    }
    .device-container-body{
        padding: 10px 20px;
    }
    .device-details-container{
        height: auto;
        max-height: 50vh;
        overflow: auto;
    }
    .device-details-header{
        margin-top: 10px;
        margin-bottom: 0px;
    }
    .device-details-header button{
        margin-right: 20px;
        padding: 8px 12px;
        border: none;
        border-radius: 5px;
        color: white;
        cursor: pointer;
        background-color: rgba(155, 30, 30, 0.952);
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
        transition: background-color 0.5s ease;
    }
    .device-details-header button:hover{
        background-color: rgba(187, 35, 35, 0.952);
    }
    .device-details-property-container{
        margin: 30px 0px;
        padding: 6px 20px;
        border-radius: 5px;
        background-color: rgb(222, 239, 245);
    }
    .device-details-property-container p{
        margin: 0px;
    }
    .device-details-property-container input{
        border: none;
        padding: 5px 0px;
        width: 100%;
        background-color: transparent;
        outline: none;
    }
    .latest-telemetry-container{
        height: auto;
        max-height: 50vh;
        overflow: auto;
    }
    .latest-telemetry-header h5{
        font-weight: lighter;
        font-size: 16px;
    }
    .latest-telemetry-table{
        border-collapse: collapse;
        text-align: left;
        width: 100%;
        border: 1px solid rgba(175, 175, 175, 0.5);
    }
    #latest-telemetry-table-header{
        background-color: white;
    }
    .latest-telemetry-table th,.latest-telemetry-table td{
        padding: 8px 15px;
    }
    .latest-telemetry-table td{
        font-size: 14px;
    }
    .latest-telemetry-table tr:nth-child(even){
        background-color: rgb(242, 242, 242);
    }
    .latest-telemetry-table tr:nth-child(odd){
        background-color: rgba(206, 206, 206, 0.952);
    }
}
@media screen and (max-width:949px){
    .device-container{
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        background-color: white;
        position: absolute;
        top: 0vh;
        right: 0px;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        border-radius: 10px;
    }
    .device-container-header{
        color: white;
        background-color: rgba(155, 30, 30, 0.952);
        padding: 15px;
        border-radius: 10px 10px 0px 0px;
        display: flex;
        justify-content: space-between;
    }
    .device-container-header h3{
        margin: 0px;
        font-weight: lighter;
    }
    .device-container-header p{
        margin: 0px;
        cursor: pointer;
        font-size: 22px;
        margin-top: -8px;
        margin-right: 10px;
        box-sizing: border-box;
        font-weight: lighter;
    }
    .device-container-header h4{
        margin: 0px;
        font-weight: lighter;
        font-size: 14px;
    }
    .device-container-navigation-bar{
        width: 100%;
        display: flex;
        overflow: auto;
        padding: 10px 0px;
        justify-content: space-evenly;
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
    }
    .device-container-navigation-bar button{
        border: none;
        outline: none;
        margin: 0px;
        border-radius: 80px;
        padding: 8px 15px;
        cursor: pointer;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
        background-color: transparent;
        text-wrap: nowrap;
    }
    .device-container-navigation-bar button:hover{
        background-color: lightgray;
    }
    .device-container-body{
        padding: 10px 20px;
    }
    .device-details-container{
        height: auto;
        max-height: 50vh;
        overflow: auto;
    }
    .device-details-property-container{
        margin: 30px 0px;
        padding: 6px 20px;
        border-radius: 5px;
        background-color: rgb(222, 239, 245);
    }
    .device-details-property-container p{
        margin: 0px;
    }
    .device-details-property-container input{
        border: none;
        padding: 5px 0px;
        width: 100%;
        background-color: transparent;
        outline: none;
    }
    .latest-telemetry-container{
        height: auto;
        max-height: 50vh;
        overflow: auto;
    }
    .latest-telemetry-header h5{
        font-weight: lighter;
        font-size: 16px;
    }
    .latest-telemetry-table-container{
        width: 100%;
        max-height: 50vh;
        overflow: auto;
    }
    .latest-telemetry-table{
        width: 100%;
        text-align: left;
        text-wrap: nowrap;
        border-collapse: collapse;
        border: 1px solid rgba(175, 175, 175, 0.5);
    }
    #latest-telemetry-table-header{
        background-color: white;
    }
    .latest-telemetry-table th,.latest-telemetry-table td{
        padding: 8px 15px;
    }
    .latest-telemetry-table td{
        font-size: 14px;
    }
    .latest-telemetry-table tr:nth-child(even){
        background-color: rgb(242, 242, 242);
    }
    .latest-telemetry-table tr:nth-child(odd){
        background-color: rgba(206, 206, 206, 0.952);
    }
}
.device-configuration-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.device-configuration-header h5{
    font-weight: lighter;
    font-size: 16px;
}
.edit-device-configuration-button,
.import-device-configuration-button,
.device-configuration-explorer-button{
    border: none;
    margin: 0px 8px;
    padding: 6px 14px;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
}
.edit-device-configuration-button:hover,
.import-device-configuration-button:hover,
.device-configuration-explorer-button:hover{
    opacity: 0.9;
}
.device-configuration-no-config-container{
    text-align: center;
    margin: 2% 5%;
    padding: 2% 5%;
    border-radius: 10px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
}
.device-configuration-no-config-container p{
    text-align: left;
    font-size: 14px;
    margin-bottom: 4%;
}
.device-configuration-table{
    border-collapse: collapse;
    text-align: left;
    width: 100%;
    border: 1px solid rgba(175, 175, 175, 0.5);
}
#device-configuration-table-header-row{
    background-color: white;
}
.device-configuration-table tr:nth-child(even){
    background-color: rgb(242, 242, 242);
}
.device-configuration-table tr:nth-child(odd){
    background-color: rgba(206, 206, 206, 0.952);
}
.device-configuration-table th,.device-configuration-table td{
    padding: 2px 10px;
}
.device-configuration-table td{
    font-size: 14px;
}
.device-configuration-table input{
    width: 80%;
    padding: 4px;
    border: none;
    outline: none;
    background-color: transparent;
}
.device-configuration-buttons-container{
    display: flex;
    margin-top: 40px;
    justify-content: center;
}
.device-configuration-buttons-container div{
    width: 90%;
    display: flex;
    justify-content: space-between;
}
.device-configuration-buttons-container button{
    border: none;
    margin: 0px 8px;
    padding: 6px 14px;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    transition: opacity 0.3s ease;
}
.device-configuration-yes-no-message-box-container{
    position: absolute;
    top: 35%;
    left: 24%;
    width: 50%;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.device-configuration-yes-no-message-box-title-container{
    display: flex;
    padding: 15px;
    justify-content: space-between;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.device-configuration-yes-no-message-box-title-container p{
    margin: 0px;
    color: white;
}
.device-configuration-yes-no-message-box-question-container{
    display: flex;
    justify-content: center;
}
.device-configuration-yes-no-message-box-buttons-container{
    display: flex;
    padding: 1% 10%;
    margin-bottom: 10px;
    justify-content: space-between;
}
.device-configuration-yes-no-message-box-buttons-container button{
    border: none;
    margin: 0px 8px;
    padding: 6px 20px;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    transition: opacity 0.3s ease;
}
.device-configuration-yes-no-message-box-buttons-container button:hover{
    opacity: 0.9;
}
.device-configuration-message-box-container{
    position: absolute;
    top: 35%;
    left: 24%;
    width: 50%;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.device-configuration-message-box-title-container{
    display: flex;
    padding: 15px;
    justify-content: space-between;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.device-configuration-message-box-title-container p{
    margin: 0px;
    color: white;
}
.device-configuration-message-box-message-container{
    display: flex;
    justify-content: center;
}
.device-configuration-message-box-buttons-container{
    text-align: right;
    padding: 1% 5%;
    margin-bottom: 10px;
}
.device-configuration-message-box-buttons-container button{
    border: none;
    margin: 0px 8px;
    padding: 6px 20px;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    transition: opacity 0.3s ease;
}
.device-configuration-message-box-buttons-container button:hover{
    opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/CustomerUserStyles/Devices/Device.css"],"names":[],"mappings":"AAAA;IACI;QACI,sCAAsC;QACtC,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,WAAW;QACX,UAAU;QACV,sBAAsB;QACtB,gCAAgC;IACpC;IACA;QACI,YAAY;QACZ,0CAA0C;QAC1C,aAAa;QACb,+BAA+B;QAC/B,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;QACf,eAAe;IACnB;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,0CAA0C;IAC9C;IACA;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,eAAe;QACf,0CAA0C;QAC1C,6BAA6B;QAC7B,iBAAiB;IACrB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,cAAc;IAClB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,0CAA0C;QAC1C,0CAA0C;QAC1C,sCAAsC;IAC1C;IACA;QACI,0CAA0C;IAC9C;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,oCAAoC;IACxC;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,WAAW;QACX,6BAA6B;QAC7B,aAAa;IACjB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,cAAc;IAClB;IACA;QACI,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,WAAW;QACX,0CAA0C;IAC9C;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,oCAAoC;IACxC;IACA;QACI,4CAA4C;IAChD;AACJ;AACA;IACI;QACI,sCAAsC;QACtC,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,YAAY;QACZ,WAAW;QACX,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,0CAA0C;QAC1C,aAAa;QACb,gCAAgC;QAChC,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,WAAW;QACX,aAAa;QACb,cAAc;QACd,iBAAiB;QACjB,6BAA6B;QAC7B,0CAA0C;IAC9C;IACA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,mBAAmB;QACnB,iBAAiB;QACjB,eAAe;QACf,0CAA0C;QAC1C,6BAA6B;QAC7B,iBAAiB;IACrB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,cAAc;IAClB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,oCAAoC;IACxC;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,WAAW;QACX,6BAA6B;QAC7B,aAAa;IACjB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,cAAc;IAClB;IACA;QACI,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,cAAc;IAClB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,iBAAiB;QACjB,yBAAyB;QACzB,0CAA0C;IAC9C;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,oCAAoC;IACxC;IACA;QACI,4CAA4C;IAChD;AACJ;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,eAAe;AACnB;AACA;;;IAGI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,6BAA6B;AACjC;AACA;;;IAGI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,0CAA0C;AAC9C;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,oCAAoC;AACxC;AACA;IACI,4CAA4C;AAChD;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB","sourcesContent":["@media screen and (min-width:950px){\r\n    .device-container{\r\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n        background-color: white;\r\n        position: absolute;\r\n        top: 2vh;\r\n        right: 0px;\r\n        height: 95%;\r\n        width: 70%;\r\n        box-sizing: border-box;\r\n        border-radius: 10px 0px 0px 10px;\r\n    }\r\n    .device-container-header{\r\n        color: white;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        padding: 15px;\r\n        border-radius: 10px 0px 0px 0px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .device-container-header h3{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n    }\r\n    .device-container-header p{\r\n        margin: 0px;\r\n        margin-right: 20px;\r\n        font-weight: lighter;\r\n        font-size: 30px;\r\n        cursor: pointer;\r\n    }\r\n    .device-container-header h4{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n        font-size: 14px;\r\n    }\r\n    .device-container-navigation-bar{\r\n        padding: 10px 0px;\r\n        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .device-container-navigation-bar button{\r\n        border: none;\r\n        outline: none;\r\n        margin: 0px 10px;\r\n        border-radius: 80px;\r\n        padding: 8px 15px;\r\n        cursor: pointer;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n        background-color: transparent;\r\n        text-wrap: nowrap;\r\n    }\r\n    .device-container-navigation-bar button:hover{\r\n        background-color: lightgray;\r\n    }\r\n    .device-container-body{\r\n        padding: 10px 20px;\r\n    }\r\n    .device-details-container{\r\n        height: auto;\r\n        max-height: 50vh;\r\n        overflow: auto;\r\n    }\r\n    .device-details-header{\r\n        margin-top: 10px;\r\n        margin-bottom: 0px;\r\n    }\r\n    .device-details-header button{\r\n        margin-right: 20px;\r\n        padding: 8px 12px;\r\n        border: none;\r\n        border-radius: 5px;\r\n        color: white;\r\n        cursor: pointer;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);\r\n        transition: background-color 0.5s ease;\r\n    }\r\n    .device-details-header button:hover{\r\n        background-color: rgba(187, 35, 35, 0.952);\r\n    }\r\n    .device-details-property-container{\r\n        margin: 30px 0px;\r\n        padding: 6px 20px;\r\n        border-radius: 5px;\r\n        background-color: rgb(222, 239, 245);\r\n    }\r\n    .device-details-property-container p{\r\n        margin: 0px;\r\n    }\r\n    .device-details-property-container input{\r\n        border: none;\r\n        padding: 5px 0px;\r\n        width: 100%;\r\n        background-color: transparent;\r\n        outline: none;\r\n    }\r\n    .latest-telemetry-container{\r\n        height: auto;\r\n        max-height: 50vh;\r\n        overflow: auto;\r\n    }\r\n    .latest-telemetry-header h5{\r\n        font-weight: lighter;\r\n        font-size: 16px;\r\n    }\r\n    .latest-telemetry-table{\r\n        border-collapse: collapse;\r\n        text-align: left;\r\n        width: 100%;\r\n        border: 1px solid rgba(175, 175, 175, 0.5);\r\n    }\r\n    #latest-telemetry-table-header{\r\n        background-color: white;\r\n    }\r\n    .latest-telemetry-table th,.latest-telemetry-table td{\r\n        padding: 8px 15px;\r\n    }\r\n    .latest-telemetry-table td{\r\n        font-size: 14px;\r\n    }\r\n    .latest-telemetry-table tr:nth-child(even){\r\n        background-color: rgb(242, 242, 242);\r\n    }\r\n    .latest-telemetry-table tr:nth-child(odd){\r\n        background-color: rgba(206, 206, 206, 0.952);\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .device-container{\r\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n        background-color: white;\r\n        position: absolute;\r\n        top: 0vh;\r\n        right: 0px;\r\n        height: 100%;\r\n        width: 100%;\r\n        box-sizing: border-box;\r\n        border-radius: 10px;\r\n    }\r\n    .device-container-header{\r\n        color: white;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        padding: 15px;\r\n        border-radius: 10px 10px 0px 0px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .device-container-header h3{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n    }\r\n    .device-container-header p{\r\n        margin: 0px;\r\n        cursor: pointer;\r\n        font-size: 22px;\r\n        margin-top: -8px;\r\n        margin-right: 10px;\r\n        box-sizing: border-box;\r\n        font-weight: lighter;\r\n    }\r\n    .device-container-header h4{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n        font-size: 14px;\r\n    }\r\n    .device-container-navigation-bar{\r\n        width: 100%;\r\n        display: flex;\r\n        overflow: auto;\r\n        padding: 10px 0px;\r\n        justify-content: space-evenly;\r\n        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .device-container-navigation-bar button{\r\n        border: none;\r\n        outline: none;\r\n        margin: 0px;\r\n        border-radius: 80px;\r\n        padding: 8px 15px;\r\n        cursor: pointer;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n        background-color: transparent;\r\n        text-wrap: nowrap;\r\n    }\r\n    .device-container-navigation-bar button:hover{\r\n        background-color: lightgray;\r\n    }\r\n    .device-container-body{\r\n        padding: 10px 20px;\r\n    }\r\n    .device-details-container{\r\n        height: auto;\r\n        max-height: 50vh;\r\n        overflow: auto;\r\n    }\r\n    .device-details-property-container{\r\n        margin: 30px 0px;\r\n        padding: 6px 20px;\r\n        border-radius: 5px;\r\n        background-color: rgb(222, 239, 245);\r\n    }\r\n    .device-details-property-container p{\r\n        margin: 0px;\r\n    }\r\n    .device-details-property-container input{\r\n        border: none;\r\n        padding: 5px 0px;\r\n        width: 100%;\r\n        background-color: transparent;\r\n        outline: none;\r\n    }\r\n    .latest-telemetry-container{\r\n        height: auto;\r\n        max-height: 50vh;\r\n        overflow: auto;\r\n    }\r\n    .latest-telemetry-header h5{\r\n        font-weight: lighter;\r\n        font-size: 16px;\r\n    }\r\n    .latest-telemetry-table-container{\r\n        width: 100%;\r\n        max-height: 50vh;\r\n        overflow: auto;\r\n    }\r\n    .latest-telemetry-table{\r\n        width: 100%;\r\n        text-align: left;\r\n        text-wrap: nowrap;\r\n        border-collapse: collapse;\r\n        border: 1px solid rgba(175, 175, 175, 0.5);\r\n    }\r\n    #latest-telemetry-table-header{\r\n        background-color: white;\r\n    }\r\n    .latest-telemetry-table th,.latest-telemetry-table td{\r\n        padding: 8px 15px;\r\n    }\r\n    .latest-telemetry-table td{\r\n        font-size: 14px;\r\n    }\r\n    .latest-telemetry-table tr:nth-child(even){\r\n        background-color: rgb(242, 242, 242);\r\n    }\r\n    .latest-telemetry-table tr:nth-child(odd){\r\n        background-color: rgba(206, 206, 206, 0.952);\r\n    }\r\n}\r\n.device-configuration-header{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n.device-configuration-header h5{\r\n    font-weight: lighter;\r\n    font-size: 16px;\r\n}\r\n.edit-device-configuration-button,\r\n.import-device-configuration-button,\r\n.device-configuration-explorer-button{\r\n    border: none;\r\n    margin: 0px 8px;\r\n    padding: 6px 14px;\r\n    border-radius: 8px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n    transition: opacity 0.3s ease;\r\n}\r\n.edit-device-configuration-button:hover,\r\n.import-device-configuration-button:hover,\r\n.device-configuration-explorer-button:hover{\r\n    opacity: 0.9;\r\n}\r\n.device-configuration-no-config-container{\r\n    text-align: center;\r\n    margin: 2% 5%;\r\n    padding: 2% 5%;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);\r\n}\r\n.device-configuration-no-config-container p{\r\n    text-align: left;\r\n    font-size: 14px;\r\n    margin-bottom: 4%;\r\n}\r\n.device-configuration-table{\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n    width: 100%;\r\n    border: 1px solid rgba(175, 175, 175, 0.5);\r\n}\r\n#device-configuration-table-header-row{\r\n    background-color: white;\r\n}\r\n.device-configuration-table tr:nth-child(even){\r\n    background-color: rgb(242, 242, 242);\r\n}\r\n.device-configuration-table tr:nth-child(odd){\r\n    background-color: rgba(206, 206, 206, 0.952);\r\n}\r\n.device-configuration-table th,.device-configuration-table td{\r\n    padding: 2px 10px;\r\n}\r\n.device-configuration-table td{\r\n    font-size: 14px;\r\n}\r\n.device-configuration-table input{\r\n    width: 80%;\r\n    padding: 4px;\r\n    border: none;\r\n    outline: none;\r\n    background-color: transparent;\r\n}\r\n.device-configuration-buttons-container{\r\n    display: flex;\r\n    margin-top: 40px;\r\n    justify-content: center;\r\n}\r\n.device-configuration-buttons-container div{\r\n    width: 90%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.device-configuration-buttons-container button{\r\n    border: none;\r\n    margin: 0px 8px;\r\n    padding: 6px 14px;\r\n    border-radius: 8px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: opacity 0.3s ease;\r\n}\r\n.device-configuration-yes-no-message-box-container{\r\n    position: absolute;\r\n    top: 35%;\r\n    left: 24%;\r\n    width: 50%;\r\n    border-radius: 10px;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.device-configuration-yes-no-message-box-title-container{\r\n    display: flex;\r\n    padding: 15px;\r\n    justify-content: space-between;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.device-configuration-yes-no-message-box-title-container p{\r\n    margin: 0px;\r\n    color: white;\r\n}\r\n.device-configuration-yes-no-message-box-question-container{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.device-configuration-yes-no-message-box-buttons-container{\r\n    display: flex;\r\n    padding: 1% 10%;\r\n    margin-bottom: 10px;\r\n    justify-content: space-between;\r\n}\r\n.device-configuration-yes-no-message-box-buttons-container button{\r\n    border: none;\r\n    margin: 0px 8px;\r\n    padding: 6px 20px;\r\n    border-radius: 8px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: opacity 0.3s ease;\r\n}\r\n.device-configuration-yes-no-message-box-buttons-container button:hover{\r\n    opacity: 0.9;\r\n}\r\n.device-configuration-message-box-container{\r\n    position: absolute;\r\n    top: 35%;\r\n    left: 24%;\r\n    width: 50%;\r\n    border-radius: 10px;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.device-configuration-message-box-title-container{\r\n    display: flex;\r\n    padding: 15px;\r\n    justify-content: space-between;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.device-configuration-message-box-title-container p{\r\n    margin: 0px;\r\n    color: white;\r\n}\r\n.device-configuration-message-box-message-container{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.device-configuration-message-box-buttons-container{\r\n    text-align: right;\r\n    padding: 1% 5%;\r\n    margin-bottom: 10px;\r\n}\r\n.device-configuration-message-box-buttons-container button{\r\n    border: none;\r\n    margin: 0px 8px;\r\n    padding: 6px 20px;\r\n    border-radius: 8px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: opacity 0.3s ease;\r\n}\r\n.device-configuration-message-box-buttons-container button:hover{\r\n    opacity: 0.9;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
